import React from "react";
import CountUp from "react-countup";
import { Clock, UserCheck, Users, UserX } from "lucide-react";

import { Summary } from "../../../components/ui/Summary";
import { CrmPetController } from "../../../services/controllers/crmPet";
import { useCrmPet } from "../../../store/crmPet/useCrmPet";

export function CrmPetSummary() {
  CrmPetController();
  const loading = useCrmPet((st) => st.data.isLoading);
  const summary = useCrmPet((st) => st.data.summary);

  return (
    <Summary.Root>
      <Summary.Box>
        <Summary.Icon icon={Users} />
        <Summary.TextContent>
          <Summary.Title>
            <CountUp end={loading ? 0 : summary.totalAll} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Total de pets</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>
      <Summary.Box>
        <Summary.Icon icon={UserCheck} />
        <Summary.TextContent>
          <Summary.Title>
            <CountUp end={loading ? 0 : summary.realizados} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Realizados</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>
      <Summary.Box>
        <Summary.Icon icon={Clock} />
        <Summary.TextContent>
          <Summary.Title>
            <CountUp end={loading ? 0 : summary.pendentes} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Pendentes</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>
      <Summary.Box>
        <Summary.Icon icon={UserX} />
        <Summary.TextContent>
          <Summary.Title>
            <CountUp end={loading ? 0 : summary.bloqueados} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Bloqueados</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>
    </Summary.Root>
  );
}
